import React, { useState } from "react";
import localeText from "../../../../locale";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";
import useBankTransfers from "../../../../hooks/useGetBankTransfers";
import { formatDate } from "../../../../utilities/formatDate";
import { Button } from "primereact/button";
import { useToggle } from "../../../../hooks/useToggle";
import useConfirmTransferRegisterUser from "../../../../hooks/useConfirmTransferRegisterUser";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import { Dialog } from "primereact/dialog";
import Loading from "../../../../components/Loading/Loading";

const BankTransfers = () => {
  const { showErrorToast } = useToastContext();
  const [currentTranfer, setCurrentTranfer] = useState(null);
  const { loadingTransfers, transfers, fetchTransfers } = useBankTransfers({
    onBankTransferError: (code) => showErrorToast({ code }),
  });
  const {
    value: authorizeTransferIsVisible,
    setAsTrue: setVisibleAuthorizeTransfer,
    setAsFalse: setNotVisibleAuthorizeTransfer,
  } = useToggle();
  const { confirmTransfer, loadingConfirmTransfer } = useConfirmTransferRegisterUser({
    onError: (code) => showErrorToast({ code }),
    onSuccess: () => {
      setNotVisibleAuthorizeTransfer();
      fetchTransfers();
    },
  });

  const filters2 = {
    "user.username": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "plan.description": { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  const handleCloseModal = () => {
    setCurrentTranfer(null);
    setNotVisibleAuthorizeTransfer();
  };

  return (
    <>
      <Dialog
        header={localeText("confirmYourAction")}
        visible={authorizeTransferIsVisible}
        draggable={false}
        className="w-30rem m-2"
        onHide={() => {
          if (!loadingConfirmTransfer) handleCloseModal();
        }}
      >
        <div className="flex flex-column gap-4">
          <p className="m-0">{localeText("confirmYourAction")}</p>
          <div className="flex gap-2 justify-content-end">
            <Button onClick={handleCloseModal} severity="danger" disabled={loadingConfirmTransfer}>
              {localeText("no")}
            </Button>
            <Button
              onClick={async () => await confirmTransfer({ idorder: currentTranfer.id })}
              disabled={loadingConfirmTransfer}
              className={`${loadingConfirmTransfer ? "opacity-80" : ""}`}
            >
              <div className="flex justify-content-center align-items-center gap-2">
                {loadingConfirmTransfer && <Loading classNameIcon={"text-sm"} disableMargin />}
                <p>{localeText("yes")}</p>
              </div>
            </Button>
          </div>
        </div>
      </Dialog>

      <div className="card border-1 border-300">
        <h3 className="my-4">{localeText("bankTransfers")}</h3>
        <hr />

        <DataTable
          className="mt-4 mb-6 p-datatable-customers"
          value={transfers}
          paginator
          responsiveLayout="scroll"
          loading={loadingTransfers}
          dataKey="id"
          filters={filters2}
          filterDisplay="row"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate={localeText("showingFirstToLast")}
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
        >
          <Column
            field="user.username"
            header={"Username"}
            style={{ width: "30%" }}
            filter
            filterPlaceholder={localeText("searchBySeller")}
            filters={filters2}
            filterDisplay="row"
            sortable
          />
          <Column
            header={localeText("plan")}
            field="plan.description"
            style={{ width: "15%" }}
            filter
            filterPlaceholder={localeText("searchByTitle")}
            filters={filters2}
            filterDisplay="row"
            sortable
          />
          <Column
            header={localeText("requestDate")}
            style={{ width: "15%" }}
            body={(transfer) => {
              const transferDate = formatDate(transfer.date);
              return <>{transferDate}</>;
            }}
            sortable
          />
          <Column
            header={localeText("receipt")}
            style={{ width: "15%" }}
            body={(transfer) => {
              return (
                <Button onClick={() => window.open(transfer.transferbankReceipt, "_blank")}>
                  {localeText("receipt")}
                </Button>
              );
            }}
            sortable
          />

          <Column
            header={localeText("authorize")}
            style={{ width: "15%" }}
            body={(transfer) => {
              return (
                <Button
                  label={localeText("authorize")}
                  icon="pi pi-check"
                  className="p-button-success p-button-rounded"
                  onClick={() => {
                    setVisibleAuthorizeTransfer();
                    setCurrentTranfer(transfer);
                  }}
                />
              );
            }}
          />
        </DataTable>
      </div>
    </>
  );
};

export default BankTransfers;
